import { Routes } from "@angular/router";

/**
 * Top-level routes for the customer kiosk application.
 *
 * The customer application currently has a single domain (`queue`); any new
 * customer-facing flow gets its own folder under `domains/` and is mounted
 * here as a sibling lazy-loaded child.
 */
export const customerRoutes: Routes = [
  { path: "", redirectTo: "queue", pathMatch: "full" },
  {
    path: "queue",
    loadChildren: () => import("./domains/queue/queue.routes").then(r => r.queueRoutes),
  },
];
